import { lazyRoute } from './lazyRoute';

export function crudChildren(
  listPage: string,
  formPage: string,
  // Merged into the 'new'/':id' handles — e.g. `{ hideBreadcrumbs: true }`
  // for a form page that renders its own back link instead of the app-wide
  // breadcrumb trail.
  formHandle?: Record<string, unknown>,
) {
  return [
    { index: true, lazy: () => lazyRoute(listPage) },
    {
      handle: { title: 'add', ...formHandle },
      lazy: () => lazyRoute(formPage),
      path: 'new',
    },
    {
      handle: { title: 'edit', ...formHandle },
      lazy: () => lazyRoute(formPage),
      path: ':id',
    },
  ];
}

export function crudChildrenWithPreview(
  listPage: string,
  formPage: string,
  idParam: string,
  formHandle?: Record<string, unknown>,
) {
  return [
    {
      handle: { title: 'add', ...formHandle },
      lazy: () => lazyRoute(formPage),
      path: 'new',
    },
    {
      children: [
        { index: true, lazy: () => lazyRoute(formPage) },
        { lazy: () => lazyRoute('/PlayerPage/PlayerPage'), path: 'preview' },
      ],
      handle: { title: 'edit', ...formHandle },
      path: idParam,
    },
    { index: true, lazy: () => lazyRoute(listPage) },
  ];
}
